import { render } from "./BaseCounter.vue?vue&type=template&id=7123a35d"
import script from "./BaseCounter.vue?vue&type=script&lang=js"
export * from "./BaseCounter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__